// src/components/Pages/BrochurewarePage.js
import React from 'react';
import { Container, Title, Text, Button, Stack, Center, Paper, Box } from '@mantine/core'; // Added Box
import { Link } from 'react-router-dom';

// 1. IMPORT YOUR BACKGROUND IMAGE
// Make sure this path is correct and the image exists in your project.
// For example, create src/assets/images/ and place your image there.
import backgroundImage from '../../assets/images/brochure-background.jpg'; // Adjust path as needed

function BrochurewarePage() {
  return (
    // 2. ADD AN OUTER BOX FOR THE BACKGROUND IMAGE
    <Box
      style={{
        minHeight: '100vh',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover', // Cover the entire area
        backgroundPosition: 'center', // Center the image
        backgroundRepeat: 'no-repeat', // Don't repeat the image
        display: 'flex',
        flexDirection: 'column', // Allows footer to be pushed to the bottom
      }}
    >
      {/* The existing Container now sits inside the Box with the background */}
      {/* It will grow to push the footer down */}
      <Container size="lg" style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Center style={{ flexGrow: 1, padding: '2rem 0' }}> {/* Added padding */}
          {/* The Paper component will sit on top of the background image */}
          <Paper shadow="xl" p="xl" radius="md" withBorder style={{ maxWidth: '700px', width: '100%' }}>
            <Stack align="stretch" gap="xl">
              <Title order={1} ta="center" style={{ fontSize: 'clamp(2rem, 5vw, 3rem)' }}>
                The Love Inc. Writer Hub™
              </Title>
              <Text size="xl" ta="center" c="dimmed">
                Quality content, loved by millions.
              </Text>
              <Text ta="center">
                Welcome to Writer Hub™, the portal for Love Inc. creators and editors. Explore resources, test and submit ideas, access content platforms and deep-dive intel.
              </Text>
              <Button
                component={Link}
                to="/menu"
                size="lg"
                variant="gradient"
                gradient={{ from: 'indigo', to: 'cyan' }}
                fullWidth
              >
                Access Systems
              </Button>
              <Button
                variant="outline"
                size="lg"
                fullWidth
                onClick={() => alert('More information about working with us will be available here soon!')}
              >
                Work With Us
              </Button>
            </Stack>
          </Paper>
        </Center>

        {/* 3. FOOTER TEXT */}
        {/* Consider the readability of this text against your chosen background image. */}
        {/* You might need to adjust its color. 'white' is often a safe bet for dark/busy images. */}
        {/* If c="dimmed" is hard to read, try style={{ color: 'white' }} or another contrasting color. */}
        <Text ta="center" c="dimmed" size="sm" py="md" style={{ color: 'white' /* Adjust if needed for readability */ }}>
          &copy; {new Date().getFullYear()} StudioFi. All rights reserved.
        </Text>
      </Container>
    </Box>
  );
}

export default BrochurewarePage;